import React from 'react';
import { colors } from '@keen.io/colors';
import { getIcon } from './utils';
export var Icon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 15 : _b, _c = _a.height, height = _c === void 0 ? 15 : _c, _d = _a.opacity, opacity = _d === void 0 ? 1 : _d, _e = _a.fill, fill = _e === void 0 ? colors.white['500'] : _e, type = _a.type;
    return React.createElement(getIcon(type), { fill: fill, opacity: opacity, width: width, height: height });
};
export default Icon;
